'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _merge = require('lodash/merge');

var _merge2 = _interopRequireDefault(_merge);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (_ref, _ref2) {
  var background = _ref.background,
      fill = _ref.fill,
      radius = _ref.radius,
      _ref$progress = _ref.progress,
      progress = _ref$progress === undefined ? 0 : _ref$progress,
      styles = _ref.styles;
  var rhythm = _ref2.rhythm,
      colors = _ref2.colors,
      radiuses = _ref2.radiuses;

  var defaultStyles = {
    root: {
      background: colors[background],
      borderRadius: rhythm(radiuses[radius]),
      height: rhythm(1),
      position: 'relative'
    },

    fill: {
      background: colors[fill],
      borderRadius: rhythm(radiuses[radius]),
      position: 'absolute',
      top: 0,
      left: 0,
      width: progress + '%',
      maxWidth: '100%',
      height: rhythm(1)
    },

    alt: {
      position: 'absolute',
      left: '-10000px',
      top: 'auto',
      width: '1px',
      height: '1px',
      overflow: 'hidden'
    }
  };

  return (0, _merge2.default)(defaultStyles, styles);
};


//////////////////
// WEBPACK FOOTER
// ../~/constructicon/progress-bar/styles.js
// module id = 914
// module chunks = 0